export const SET_DATES = 'calendar/SET_DATES';
